import React from 'react';
import styled from 'styled-components';
import { get, isNil } from 'lodash';
import { Label, Table } from 'semantic-ui-react';

const CellContainer = styled.div`
    display: flex;
    align-items: center;
    ${props => props.nowrap && 'white-space: nowrap;'}
`;

const CornerFilter = styled(Label).attrs({
    corner: 'right',
    icon: 'filter' })`

    cursor: pointer;

    // fixing bug in semantic-ui where corner icons dont show cursor
    &.ui.corner.label .icon {
        cursor: inherit;
    }
`;

// Our table component
function TableView({
    tableProps,
    rowsOrPage,
    getStickyHeight,
    freeze
}) {
    const groupKey = rowsOrPage.length ? rowsOrPage[0].groupKey : null;
    const {
        getTableBodyProps,
        headerGroups,
        prepareRow,
    } = tableProps;
    // this is used to augment the data with the groupContext so that we can use it in the checkboxs.
    const RenderHeader = (data) => {
        if (typeof data === 'object') {
            return {
                ...data,
                props: {
                    ...data.props,
                    groupContext: groupKey
                }
            };
        }
        return data;
    };
    return (
        <React.Fragment>
            <Table.Header>
                {headerGroups.map(headerGroup => (
                    <Table.Row {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => {
                            let sorted = null;
                            if (column.isSorted) {
                                sorted = column.isSortedDesc ? 'descending' : 'ascending';
                            }
                            return (
                                <Table.HeaderCell
                                    width={column.widthOverride || null}
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                    sorted={sorted}
                                    style={{
                                        ...(freeze ? {
                                            top: getStickyHeight(),
                                            zIndex: '10',
                                            position: 'sticky'
                                        } : {})
                                    }}
                                >
                                    {RenderHeader(column.render('Header'))}
                                </Table.HeaderCell>
                            );
                        })}
                    </Table.Row>
                ))}
            </Table.Header>
            <Table.Body {...getTableBodyProps()}>
                {rowsOrPage.map((row) => {
                    prepareRow(row);
                    const activeFilters = tableProps.state.filters;
                    const hasEqualsFilter = (filter, cell) => filter.id === cell.column.id && ['Equals', '='].includes(filter.value.filter);
                    return (
                        <Table.Row {...row.getRowProps()}>
                            {
                                row.cells.map(cell => (
                                    <Table.Cell
                                        {...get(cell, 'column.cellProps', {})}
                                        style={{ position: 'relative', fontSize: '13px', paddingTop: '15px', verticalAlign: 'middle', width: get(cell, 'column.width', 'auto') }}
                                        {...get(cell, 'row.original.style', {})}
                                        {...cell.getCellProps()}
                                    >
                                        <CellContainer nowrap={cell.column.nowrap}>
                                            {cell.render('Cell')}
                                            {!isNil(cell.value)
                                                && !!cell.column.quickFilter
                                                && !activeFilters.some(filter => hasEqualsFilter(filter, cell)) &&
                                                    <CornerFilter className='quick-filter-button'
                                                        size='mini'
                                                        onClick={() => {
                                                            let headerText = cell.column.Header;
                                                            if (typeof headerText !== 'string') {
                                                                headerText = cell.column.id;
                                                            }

                                                            return cell.column.setFilter({
                                                                column: headerText,
                                                                filter: cell.column.quickFilter.label,
                                                                fn: cell.column.quickFilter.fn,
                                                                value: cell.value
                                                            });
                                                        }}
                                                    />
                                            }
                                        </CellContainer>
                                    </Table.Cell>
                                ))
                            }
                        </Table.Row>
                    );
                })}
            </Table.Body>
        </React.Fragment>
    );
}

export default TableView;



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/TableView.js